export default __webpack_public_path__ + "static/about-13466014cee89dc6802373a232c03dfe.svg";